export default "__VITE_ASSET__CYQCk8LJ__"